import React from "react";
import "primereact/resources/themes/saga-blue/theme.css"; // Import theme (you can choose another theme)
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons
import {Menubar} from "primereact/menubar";
import {Button} from "primereact/button";
import {MultiStateCheckbox} from "primereact/multistatecheckbox";
import "@fortawesome/fontawesome-free/css/all.min.css";
import {useNavigate, useParams} from "react-router-dom";
import {performLogout} from "./AuthRoute";
import {motion} from "framer-motion";
import UsersOnThisPage from "./UsersOnThisPage";

const MenuBar = ({
                     lastUpdated,
                     onConfirm,
                     onNext,
                     onPrevious,
                     centerItem,
                     currentFileName,
                     currentFileDone,
                     currentFileNbrSelectedItems,
                     depthsVisibility,
                     setDepthsVisibility,
                     descriptionsVisibility,
                     setDescriptionsVisibility,
                     latestTabs,
                 }) => {
    const navigate = useNavigate();
    const {sondageId} = useParams();
    const {projectName} = useParams();

    const getColorFromUsername = (username) => {
        let hash = 0;
        for (let i = 0; i < username.length; i++) {
            hash = username.charCodeAt(i) + ((hash << 5) - hash);
        }
        const hue = Math.abs(hash) % 360;
        return `hsl(${hue}, 70%, 50%)`;
    };

    const items = [
        {
            label: "Home",
            icon: "pi pi-fw pi-home",
            command: () => {
                navigate(`/`);
            },
        },
        {
            label: projectName,
            icon: "pi pi-fw pi-folder",
            command: () => {
                navigate(`/${encodeURIComponent(projectName)}/project/1`);
            },
        },
        {
            label: "Sondages",
            icon: "pi pi-fw pi-table",
            command: () => {
                navigate(`/all-sondages`);
            },
        },
        {
            label: "Search",
            icon: "pi pi-fw pi-search",
            command: () => {
                navigate(`/search`);
            },
        },
        {
            label: "Graphs",
            icon: "pi pi-fw pi-chart-bar",
            command: () => {
                navigate(`/graphs`);
            },
        },
        {
            label: "Download Center",
            icon: "pi pi-fw pi-cloud-download",
            command: () => {
                navigate(`/download-center`);
            }
        }
    ];

    if (!projectName) {
        items.splice(1, 1); // Remove the projectName item if it's undefined
    }

    const askConfirmation = (message, callback) => {
        // const confirmed = window.confirm(message);
        // if (confirmed) {
        callback();
        // }
    };

    const center = (
        <div
            style={{
                position: "absolute",
                width: "100%",
                alignContent: "center",
                textAlign: "center",
                top: "4px",
                height: "69px",
            }}
        >
            {centerItem}
        </div>
    );

    const end = (
        <div style={{display: "flex", alignItems: "center"}}>
            {/*<div*/}
            {/*  style={{*/}
            {/*    display: "flex",*/}
            {/*    alignItems: "center",*/}
            {/*    gap: "10px",*/}
            {/*    marginRight: "30px",*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>*/}
            {/*    <p>Depths:</p>*/}
            {/*    <MultiStateCheckbox*/}
            {/*      value={depthsVisibility}*/}
            {/*      onChange={(e) => setDepthsVisibility(e.value)}*/}
            {/*      options={visibilityOptions}*/}
            {/*      optionValue={"value"}*/}
            {/*      tooltip={depthsVisibility}*/}
            {/*      tooltipOptions={{ position: "bottom" }}*/}
            {/*      empty={false}*/}
            {/*    />*/}
            {/*  </div>*/}
            {/*  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>*/}
            {/*    <p>Descriptions:</p>*/}
            {/*    <MultiStateCheckbox*/}
            {/*      value={descriptionsVisibility}*/}
            {/*      onChange={(e) => setDescriptionsVisibility(e.value)}*/}
            {/*      options={visibilityOptions}*/}
            {/*      optionValue={"value"}*/}
            {/*      tooltip={"Visibility" + descriptionsVisibility}*/}
            {/*      tooltipOptions={{ position: "bottom" }}*/}
            {/*      empty={false}*/}
            {/*    />*/}
            {/*  </div>*/}
            {/*</div>*/}

            {sondageId && (
                <>
                    <UsersOnThisPage latestTabs={latestTabs} showTime={true}/> {" | "}
                </>
            )}

            {/*<div*/}
            {/*  style={{*/}
            {/*    display: "flex",*/}
            {/*    alignItems: "center",*/}
            {/*    gap: "10px",*/}
            {/*    marginRight: "30px",*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <p style={{ margin: "0px" }}>{currentFileName} | </p>*/}
            {/*  <p style={{ margin: "0px" }}>*/}
            {/*    {currentFileDone ? "Done 😃" : "Not done 😑"}*/}
            {/*
      {/*  </p>*/}
            {/*</div>*/}
            {lastUpdated && "Last updated: " + lastUpdated}
            <br/>

            {currentFileDone ? (
                <Button
                    icon={<i className="pi pi-bookmark" style={{marginRight: "8px"}}/>}
                    className="p-button-warning"
                    onClick={() =>
                        askConfirmation("Want to mark it as undone?", onConfirm)
                    }
                    // tooltip={`Overwrite the document ${currentFileName}`}
                    tooltipOptions={{position: "bottom"}}
                    style={{marginRight: "10px"}}
                >
                    Mark as undone
                    {/*overwrite ({currentFileNbrSelectedItems} items)*/}
                </Button>
            ) : (
                <Button
                    icon="pi pi-save"
                    className="p-button-success"
                    onClick={() => askConfirmation("Want to mark it as done?", onConfirm)}
                    // tooltip={`Save the document ${currentFileName}`}
                    tooltipOptions={{position: "bottom"}}
                    style={{marginRight: "10px"}}
                >
                    Mark as done
                    {/*Save {currentFileNbrSelectedItems} items*/}
                </Button>
            )}
            {projectName === "undefined" ? (
                <p></p>
            ) : (
                <>
                    <Button
                        icon="pi pi-arrow-left"
                        className="p-button-secondary"
                        onClick={() =>
                            askConfirmation("Discard and open previous doc?", onPrevious)
                        }
                        tooltip="Previous Document"
                        tooltipOptions={{position: "bottom"}}
                        style={{marginRight: "10px"}}
                    />
                    <Button
                        icon="pi pi-arrow-right"
                        className="p-button-secondary"
                        onClick={() =>
                            askConfirmation("Discard and open next doc?", onNext)
                        }
                        tooltip="Next Document"
                        tooltipOptions={{position: "bottom"}}
                    />
                </>
            )}
        </div>
    );

    const center2 = <>{sondageId === undefined ? <p></p> : center}</>;

    const end2 = (
        <>
            {sondageId === undefined ? (
                <>
                    {/* Logout Button */}
                    <Button
                        icon="pi pi-sign-out"
                        className="p-button-secondary"
                        onClick={() => {
                            performLogout();
                            navigate("/login");
                        }}
                        tooltip="Logout"
                        tooltipOptions={{position: "bottom"}}
                        style={{marginLeft: "20px"}} // Add some margin for spacing
                    >
                        Logout
                    </Button>
                </>
            ) : (
                end
            )}
        </>
    );

    return (
        <div style={{position: "fixed", top: 0, width: "100%", zIndex: 1000}}>
            <Menubar start={center2} model={items} end={end2}/>
        </div>
    );
};

export default MenuBar;

export const AlwaysVisible = "always visible";
export const VisibleOnHover = "visible on hover";
export const NeverVisible = "never visible";

const visibilityOptions = [
    {value: AlwaysVisible, icon: "fa-solid fa-eye"},
    {value: VisibleOnHover, icon: "fa-solid fa-arrow-pointer"},
    {value: NeverVisible, icon: "fa-solid fa-eye-slash"},
];
